import { corners, marginTop, marginY, padding, typography } from "../../common/styles";
import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import { ActionType } from "../../AppDataProvider/actions";
import { AppContext } from "../../AppDataProvider/AppDataProvider";
import { applyOpacity } from "../../common/styles/utils";
import { Button as BaseButton } from "../../common/components";
import { FocusTrap } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export function ModalDialog() {
  const theme = useTheme();
  const {
    appData,
    appDataDispatch
  } = useContext(AppContext);
  const {
    modalDialog
  } = appData;
  if (modalDialog === undefined) throw new Error("Cannot display a modal dialog when config in appData is undefined");
  const {
    buttonLabel,
    content,
    icon,
    onClick: onClickCallback,
    title
  } = modalDialog;
  const onClick = () => {
    onClickCallback();
    appDataDispatch({
      type: ActionType.HIDE_MODAL_DIALOG
    });
  };
  return <>
      <Backdrop data-sentry-element="Backdrop" data-sentry-source-file="ModalDialog.tsx" />
      <FocusTrap data-sentry-element="FocusTrap" data-sentry-source-file="ModalDialog.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="ModalDialog.tsx">
          <FontAwesomeIcon icon={icon} color={applyOpacity(theme.colours.dark, 0.8, false)} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="ModalDialog.tsx" />
          <Title data-sentry-element="Title" data-sentry-source-file="ModalDialog.tsx">{title}</Title>
          <Content data-sentry-element="Content" data-sentry-source-file="ModalDialog.tsx">{content}</Content>
          <Button variant="primary" onClick={onClick} data-sentry-element="Button" data-sentry-source-file="ModalDialog.tsx">
            {buttonLabel}
          </Button>
        </Container>
      </FocusTrap>
    </>;
}
const Backdrop = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  /*
   * Pinned to a literal static hex (not theme.colours.dark) — this is
   * conventional page-dimming scrim UI chrome, not part of the
   * dark-theme-aware dialog-panel fix (see theme.ts's computeTheme).
   */
  background: #1a1a1a;
  opacity: 0.1;
`;
const Container = styled.div`
  position: fixed;
  top: 180px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  left: 50%;
  z-index: 2;

  max-width: min(27.5rem, 90%);
  min-width: min(20rem, 100%);

  ${corners.xl}
  ${padding.l}
  background: ${({
  theme
}) => theme.colours.white};

  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.h2`
  ${typography.subtitle}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.8, false)};
  ${marginTop.s}
  &::first-letter {
    text-transform: capitalize;
  }
`;
const Content = styled.div`
  ${typography.body}
  ${marginY.m}
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
`;
const Button = styled(BaseButton)`
  width: 100%;
`;
export default ModalDialog;